import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import {purpose, resetResponse, setPatientDataForCouple, setShowEditPopup} from '../Redux/Slice/rootSlice';
import {fetchSpecificPatient, updatePatient} from '../Redux/Thunk/Actions';
import '../styles/Components/AddPatient_form.scss';

function EditPatient_form(props) {
  const [docref, setdocref] = useState(['Source Google', 'Instagram', 'Facebook', 'YouTube', 'Friends', 'Neighbour', 'Relatives', 'Doctor', 'Existing Patient']);
  const [doctorid, setdoctorid] = useState('');
  const [createUserInfo, setCreateUserInfo] = useState({
    last_name: '',
    first_name: '',
    email: '',
    phonenumber: '',
    gender: '',
    age: '',
    birthdate: null,
    blood_group: '',
    titles: '',
    doctor_id: '',
    purpose: '',
    residence: ''
  });
  // console.log(createUserInfo, "tes");
  const [alert, setAlert] = useState(false);
  const [error, setError] = useState(false);
  const adminuser = useNavigate();
  const dispatch = useDispatch();
  const excludedKeys = ['email', 'gender', 'birthdate', 'blood_group', 'doctor_id', 'residence'];
  const patientId = useSelector(state => state.counter.patientid);

  const areAllUserInfoValid = Object.keys(createUserInfo)
    .filter(key => !excludedKeys.includes(key))
    .every(key => createUserInfo[key] !== '');

  useEffect(() => {
    const fetchData = async () => {
      props.loaderchange('true');
      const addPatient = fetchSpecificPatient(patientId);
      const response = await dispatch(addPatient);

      if (response.payload?.status?.code === 200) {
        // console.log(response.payload.data, "test");
        const {phonenumber, email, first_name, last_name, titles, gender, birthdate, age, blood_group, doctor_id, doctor_referral, doctor_name, doctor_no, doctor_address, purpose, residence} =
          response.payload.data;

        setdoctorid(doctor_id);
        setCreateUserInfo({
          ...createUserInfo,
          phonenumber,
          email,
          first_name,
          last_name,
          titles,
          gender,
          birthdate: birthdate ? birthdate.split('-').reverse().join('-') : null,
          age,
          blood_group,
          doctor_id,
          doctor_referral,
          doctor_name,
          doctor_no,
          doctor_address,
          purpose,
          residence
        });

        props.loaderchange('false');
      }
    };

    fetchData();
  }, []);

  const closeUserPopup = () => {
    if (alert) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, revert it!'
      }).then(result => {
        if (result.isConfirmed) {
          adminuser('/Patients');
          setAlert(false);
          dispatch(setShowEditPopup(false));
        }
      });
    } else {
      adminuser('/Patients');
      setAlert(false);
      dispatch(setShowEditPopup(false));
    }
  };

  const handleSubmit = event => {
    event.preventDefault();
  };

  const handleChange = e => {
    setAlert(true);
    setCreateUserInfo({
      ...createUserInfo,
      [e.target.name]: e.target.value
    });
  };

  const handlePurposeChange = e => {
    const newPurpose = e.target.value;
    dispatch(purpose(newPurpose));
    setAlert(true);
    const updatedUserInfo = {
      ...createUserInfo,
      purpose: newPurpose,
      id: patientId // Add patientId here
    };
    setCreateUserInfo(updatedUserInfo);

    if (newPurpose === 'Fertility') {
      dispatch(setPatientDataForCouple({data: updatedUserInfo}));
      if (props.setCoupleCreatePopUp) {
        dispatch(setShowEditPopup(false));
        props.setCoupleCreatePopUp(true);
      }
    } else {
      if (props.setCoupleCreatePopUp) {
        props.setCoupleCreatePopUp(false);
        dispatch(setShowEditPopup(true));
      }
    }
  };

  const handleNameChange = e => {
    setAlert(true);
    if (e.target.value === '' || !e.target.value.includes(' ')) {
      setCreateUserInfo({
        ...createUserInfo,
        [e.target.name]: e.target.value
      });
    }
  };
  const handleEmailChange = e => {
    setAlert(true);

    setCreateUserInfo({
      ...createUserInfo,
      email: e.target.value
    });
  };
  const handleMobileChange = e => {
    setAlert(true);
    if (e.target.value === '' || !e.target.value.includes(' ')) {
      setCreateUserInfo({
        ...createUserInfo,
        phonenumber: e.target.value
      });
    }
  };
  const handleDobChange = e => {
    setAlert(true);
    const date = e.target.value;
    if (date) {
      const birthDate = new Date(date);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      setCreateUserInfo({
        ...createUserInfo,
        birthdate: date,
        age: age.toString()
      });
    } else {
      setCreateUserInfo({
        ...createUserInfo,
        birthdate: null,
        age: ''
      });
    }
  };
  const handleAgeChange = e => {
    setAlert(true);
    if (e.target.value === '' || !e.target.value.includes(' ')) {
      setCreateUserInfo({
        ...createUserInfo,
        age: e.target.value
      });
    }
  };

  const handleDocRefChange = e => {
    setAlert(true);

    if (e.target.value != 'Others') {
      setCreateUserInfo({
        ...createUserInfo,
        doctor_id: e.target.value
      });
      setdoctorid(e.target.value);
    } else {
      setCreateUserInfo({
        ...createUserInfo,
        doctor_id: ''
      });

      setdoctorid(e.target.value);
    }
  };

  const handleEditPatient = () => {
    const CreateThunk = async () => {
      props.loaderchange(true);
      const userInfoForSubmission = {...createUserInfo};
      const updatePatientData = updatePatient({
        userData: userInfoForSubmission,
        id: patientId
      });
      const response = await dispatch(updatePatientData);
      if (response?.payload?.status?.code === 200) {
        dispatch(setShowEditPopup(false));
        props.setUpdate(true);
        props.loaderchange(false);
        dispatch(resetResponse(''));

        Swal.fire({
          title: 'Successful.',
          text: 'Record added successful.',
          icon: 'success',
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        props.loaderchange('false');
        props.popupalert('true');
        props.popuptext('Network went wrong, Please try after some time.');
        // props.popuptext(response?.status?.message);
        dispatch(resetResponse(''));
        setTimeout(() => {
          props.popupalert('false');
        }, 2000);
      }
    };
    if (areAllUserInfoValid) {
      CreateThunk();
    } else {
      setError(true);
    }
  };

  return (
    <>
      <div className='adminform'>
        <div class='modal-dialog1' role='document'>
          <div class='modal-content modelContentChanges'>
            <div class='modal-header'>
              <h5 class='modal-title'>Update Patient Record</h5>
              <button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={e => closeUserPopup(e)}>
                <i class='bi bi-x-lg'></i>
              </button>
            </div>
            <div class='modal-body modelBodyChanges' style={{padding: '1rem', width: '920px'}}>
              <form onSubmit={handleSubmit}>
                <div class='row'>
                  <div class='col-3 title-dropdown'>
                    <label for='validationCustom01' class='form-label'>
                      <span style={{color: 'red'}}>*</span>Title
                    </label>
                    <select id='titles' name='titles' value={createUserInfo.titles} onChange={e => handleChange(e)} className='form-select'>
                      <option value='' disabled selected>
                        Select a Title
                      </option>
                      <option value='Mr'>Mr</option>
                      <option value='Mrs'>Mrs</option>
                      <option value='Miss'>Miss</option>
                    </select>

                    {error && createUserInfo.titles == '' && (
                      <p style={{fontSize: '12px', color: 'red'}}>
                        <span>Required Title</span>
                      </p>
                    )}
                  </div>
                  <div class='col-3 title-dropdown'>
                    <label for='purpose' class='form-label'>
                      Purpose
                    </label>
                    <select id='purpose' name='purpose' value={createUserInfo.purpose} onChange={e => handlePurposeChange(e)} className='form-select'>
                      <option value='' disabled selected>
                        Select Purpose
                      </option>
                      <option value='General'>General</option>
                      <option value='AN'>AN</option>
                      <option value='Fertility'>Fertility</option>
                      <option value='Gynecology'>Gynecology</option>
                    </select>
                  </div>
                </div>
                <div class='row'>
                  <div class='col mt-3'>
                    <label for='validationCustom01' class='form-label'>
                      <span style={{color: 'red'}}>*</span>First Name
                    </label>
                    <input
                      type='text'
                      class='form-control inputStyleChange'
                      id='validationCustom01'
                      name='first_name'
                      variant='standard'
                      autoComplete='off'
                      value={createUserInfo.first_name}
                      onKeyDown={e => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onChange={e => handleNameChange(e)}
                      required></input>
                    <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo.first_name === '' && <span>Required First Name</span>}</p>
                  </div>

                  <div class='col mt-3'>
                    <label for='validationCustom02' class='form-label'>
                      <span style={{color: 'red'}}>*</span>Last Name
                    </label>
                    <input
                      type='text'
                      class='form-control inputStyleChange'
                      id='validationCustom02 '
                      name='last_name'
                      autoComplete='off'
                      onChange={e => handleNameChange(e)}
                      // onBlur={handleLastNameBlur}
                      onKeyDown={e => {
                        if (e.which == '32') {
                          e.preventDefault();
                        }
                      }}
                      value={createUserInfo.last_name}
                      required></input>
                    <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo.last_name == '' && <span>Required Last Name</span>}</p>
                  </div>
                </div>
                <div class='row'>
                  <div class='col mt-3'>
                    <label for='validationCustomUsername' class='form-label'>
                      Email
                    </label>
                    <div class='input-group has-validation'>
                      <span
                        class='input-group-text mailIcon inputStyleChange'
                        id='inputGroupPrepend'
                        style={{
                          borderRadius: '6px 0px 0px 6px'
                        }}>
                        @
                      </span>
                      <input
                        type='text'
                        class='form-control inputStyleChange'
                        id='validationCustomUsername'
                        aria-describedby='inputGroupPrepend'
                        autoComplete='off'
                        value={createUserInfo.email}
                        name='email'
                        onChange={e => handleEmailChange(e)}
                        // onBlur={handleEmailBlur}
                      ></input>
                    </div>
                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.email == "" && (
                        <span>Required Email</span>
                      )}
                    </p> */}
                  </div>
                  <div class='col mt-3'>
                    <label for='validationCustom02' class='form-label'>
                      <span style={{color: 'red'}}>*</span>Mobile Number
                    </label>
                    <input
                      type='phonenumber'
                      class='form-control inputStyleChange'
                      id='validationCustom02 '
                      name='phonenumber'
                      autoComplete='off'
                      maxLength={10}
                      onChange={e => handleMobileChange(e)}
                      // onBlur={handleMobileBlur}
                      onKeyDown={e => {
                        if (e.which == '32') {
                          e.preventDefault();
                        }
                      }}
                      value={createUserInfo.phonenumber}
                      required></input>
                    <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo.phonenumber == '' && <span>Required Phone number</span>}</p>
                  </div>
                </div>
                <div class='row'>
                  <div className=' mt-4 col'>
                    <label for='validationCustom01' class='form-label'>
                      Gender
                    </label>
                    <select id='titles' name='gender' value={createUserInfo.gender} onChange={handleChange} className='form-select inputStyleChange'>
                      <option value='' disabled selected>
                        Select a Gender
                      </option>
                      <option value='Male'>Male</option>
                      <option value='Female'>Female</option>
                      <option value='Other'>Other</option>
                      <option value='Decline to State'>Decline to State</option>
                    </select>
                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.gender == "" && (
                        <span>Required Gender</span>
                      )}
                    </p> */}
                  </div>
                  <div class='col mt-4'>
                    <label for='birthdate' class='form-label'>
                      Date of Birth
                    </label>
                    <input
                      type='date'
                      name='birthdate'
                      onChange={handleDobChange}
                      value={createUserInfo.birthdate || ''}
                      className='form-control inputStyleChange'
                      id='birthdate'
                      autoComplete='off'
                      max={new Date().toISOString().split('T')[0]}
                    />
                  </div>
                  <div class='col mt-4'>
                    <label for='age' class='form-label'>
                      Age
                    </label>
                    <input
                      type='number'
                      class='form-control inputStyleChange'
                      id='age'
                      name='age'
                      autoComplete='off'
                      maxLength={2}
                      onChange={e => handleAgeChange(e)}
                      readOnly
                      // onBlur={handleMobileBlur}
                      onKeyDown={e => {
                        if (e.which == '32') {
                          e.preventDefault();
                        }
                      }}
                      value={createUserInfo.age}></input>
                  </div>
                </div>
                <div class='row'>
                  <div class='col mt-3'>
                    <label for='validationCustom02' class='form-label'>
                      Blood Group
                    </label>
                    <select id='bloodgroup' value={createUserInfo.blood_group} name='blood_group' onChange={handleChange} className='form-select inputStyleChange'>
                      <option value='' disabled selected>
                        Select Blood Group
                      </option>
                      <option value='A+'>A+</option>
                      <option value='A-'>A-</option>
                      <option value='B+'>B+</option>
                      <option value='B-'>B-</option>
                      <option value='AB+'>AB+</option>
                      <option value='AB-'>AB-</option>
                      <option value='O+'>O+</option>
                      <option value='O-'>O-</option>
                    </select>
                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.blood_group == "" && (
                        <span>Blood Group Required.</span>
                      )}
                    </p> */}
                  </div>
                  <div class='col mt-3'>
                    <label for='residence' class='form-label'>
                      Area of residence
                    </label>
                    <input
                      type='text'
                      class='form-control inputStyleChange'
                      id='residence'
                      name='residence'
                      autoComplete='off'
                      onChange={e => handleChange(e)}
                      value={createUserInfo.residence}
                      placeholder='Enter Patient Area of residence....'></input>
                  </div>
                  <div class='col mt-3'>
                    <label for='validationCustom02' class='form-label'>
                      Doctor referral
                    </label>

                    <select
                      class='form-control inputStyleChange'
                      id='validationCustom02 '
                      name='doctor_referral'
                      autoComplete='off'
                      onChange={e => handleDocRefChange(e)}
                      value={!docref.includes(doctorid) ? 'Others' : createUserInfo.doctor_id}
                      placeholder='Enter Doctor Referral....'>
                      <option value='' disabled selected>
                        Select Doctor referral
                      </option>
                      {docref.map(ele => {
                        return <option value={ele}>{ele}</option>;
                      })}
                      <option value={'Others'}>{'Others'}</option>
                    </select>
                  </div>
                </div>
                <div className='row'>
                  {!docref.includes(doctorid) ? (
                    <div class='col mt-3'>
                      <label for='validationCustom01' class='form-label'>
                        <span style={{color: 'red'}}>*</span>Others
                      </label>
                      <input
                        type='text'
                        class='form-control inputStyleChange'
                        id='validationCustom01'
                        name='first_name'
                        variant='standard'
                        value={createUserInfo.doctor_id}
                        autoComplete='off'
                        // value={createUserInfo.first_name}
                        // onKeyDown={(e) => {
                        //   if (e.target.value.length === 0 && e.which === 32) {
                        //     e.preventDefault();
                        //   }
                        // }}
                        onChange={e => {
                          setAlert(true);
                          setCreateUserInfo({
                            ...createUserInfo,
                            doctor_id: e.target.value
                          });
                        }}
                        placeholder='Enter Doctor referral....'
                        required></input>
                      <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo.first_name === '' && <span>Required Others Name</span>}</p>
                    </div>
                  ) : docref.includes(doctorid) && doctorid == 'Doctor' ? (
                    <>
                      <div className='col mt-3'>
                        <label for='validationCustom01' class='form-label'>
                          <span style={{color: 'red'}}>*</span>Doctor Name{' '}
                        </label>
                        <input
                          type='text'
                          class='form-control inputStyleChange'
                          id='validationCustom01'
                          name='doctor_name'
                          value={createUserInfo.doctor_name}
                          onChange={e => handleChange(e)}
                          variant='standard'
                          autoComplete='off'
                          placeholder='Enter Doctor Name'></input>
                      </div>
                      <div className='col mt-3'>
                        <label for='validationCustom01' class='form-label'>
                          <span style={{color: 'red'}}>*</span>Doctor phonenumber{' '}
                        </label>
                        <input
                          type='number'
                          class='form-control inputStyleChange'
                          id='validationCustom01'
                          name='doctor_no'
                          variant='standard'
                          value={createUserInfo.doctor_no}
                          onChange={e => handleChange(e)}
                          autoComplete='off'
                          placeholder='Enter Doctor Address'></input>
                      </div>
                      <div className='col mt-3'>
                        <label for='validationCustom01' class='form-label'>
                          <span style={{color: 'red'}}>*</span>Doctor Address{' '}
                        </label>
                        <textarea
                          type='text'
                          class='form-control inputStyleChange'
                          id='validationCustom01'
                          name='doctor_address'
                          value={createUserInfo.doctor_address}
                          onChange={e => handleChange(e)}
                          variant='standard'
                          autoComplete='off'
                          placeholder='Enter Doctor Address'></textarea>
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                </div>

                <button type='submit' class='btn btn-primary  create mt-3 ' onClick={e => handleEditPatient(e)} disabled={!alert}>
                  Update Patient Record
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditPatient_form;
